import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { ButtonSharedModule } from '../../atoms/button/button.module';
import { CitySelectSharedComponent } from './city-select.component';
import { JumbotronSharedModule } from '../../molecules/jumbotron/jumbotron.module';
import { SelectSharedModule } from '../../molecules/select/select.module';

@NgModule({
    declarations: [
        CitySelectSharedComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SelectSharedModule,
        ButtonSharedModule,
        JumbotronSharedModule
    ],
    exports: [
        CitySelectSharedComponent
    ],
})

export class CitySelectSharedModule {}
